import { CircularProgress } from "@material-ui/core";

const Spinner = () => {
  return (
    <div className="spinner-main">
      <div className="spinner">
        <CircularProgress />
        <div className="spinner__text">Loading...</div>
      </div>
    </div>
  );
};

export default Spinner;
